<template>
  <div class="help-center">
    <transition name="fade">
      <div class="stage" v-if="shownStage === 'outline'">
        <outlineStage></outlineStage>
      </div>
    </transition>
    <transition name="fade">
      <div class="stage" v-if="shownStage === 'tutorialTitle'">
        <tutorialTitleStage></tutorialTitleStage>
      </div>
    </transition>
    <transition name="fade">
      <tutorialContentStage v-if="shownStage === 'tutorialContent'"></tutorialContentStage>
    </transition>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import outlineStage from './outlineStage.vue';
import tutorialTitleStage from './tutorialTitleStage.vue';
import tutorialContentStage from './tutorialContentStage.vue';
export default {
  components: {
    outlineStage,
    tutorialTitleStage,
    tutorialContentStage
  },
  computed: {
    ...mapGetters({
      shownStage: 'helpCenter/shownStage'
    })
  },
  created () {
    this.fetchTutorial();
    this.$store.commit('helpCenter/setShownStage', 'outline');
  },
  methods: {
    ...mapActions({
      fetchTutorial: 'helpCenter/fetchTutorial'
    })
  }
}
</script>

<style scoped lang="scss">
.help-center {
  position: relative;
  // overflow: hidden;
  width: 100%;
  height: 100%;
}
.stage {
  position: absolute;
  width: 100%;
  height: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter {
  transform: translateX(50%);
  opacity: 0;
}
.fade-leave-to {
  transform: translateX(-50%);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/helpCenter/helpCenter.vue